export enum CustodyResidentialTypes {
    InCustody,
    InResidential,
    Suspension
}
